import {
  KevelAdBaseEntity,
  KevelAdBaseEntityParams,
} from "@shared/services/event_tracking/entities";

interface KevelBannerAdEntityParams extends KevelAdBaseEntityParams {
  placement_position?: number;
  desktop_image_url?: string;
  mobile_image_url?: string;
}

export class KevelBannerAdEntity extends KevelAdBaseEntity {
  display_position: number;
  desktop_image_url: string;
  mobile_image_url: string;

  constructor(params: KevelBannerAdEntityParams) {
    super(params);
    this.type = "kevel_banner_ad";
    this.entity_version = 3;
    this.display_position = params.placement_position;
    this.desktop_image_url = params.desktop_image_url;
    this.mobile_image_url = params.mobile_image_url;
  }
}
